import React from 'react'
import PropTypes from 'prop-types'
import Lib from '../../loader'

function Icon({ iconName, color }) {
  return <Lib.Icon iconName={iconName} color={color} />
}

Icon.defaultProps = {
  color: '#000',
}

Icon.propTypes = {
  iconName: PropTypes.string.isRequired,
  color: PropTypes.string,
}

export default Icon
